import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
// import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
import { FunctionComponent } from "react"
import { Api } from "../../../redux/api/BaseApi";
import { useReduxDispatch, useReduxSelector } from "../../../redux/hooks";
import { SetHierarchy } from "../../../slices/TicketSlice";
import HierarchyForm from "./HierarchyForm";

const TicketHierarchy: FunctionComponent<HierarchyProps> = props => {
    const dispatch = useReduxDispatch();
    const { ticket } = useReduxSelector(state => state.newTicket);

    const handleParentChange = (event) => {
        //props?.onParentChanged(event.value);
        console.log('handleParentChange', event);
        dispatch(SetHierarchy({ IsParent: event.value, Parent_Ticket_Id: null }));
    };

    const handleChildChange = (event) => {
        console.log('handleChildChange', event)
        if (event.value !== 0)
            dispatch(SetHierarchy({ Parent_Ticket_Id: null, IsParent: false }));
        else
            dispatch(SetHierarchy({ Parent_Ticket_Id: 0, IsParent: false }));
    };
    const onTicketSelected = (Id?: number) => {
        console.log('onTicketSelected', Id)
        dispatch(SetHierarchy({ Parent_Ticket_Id: Id, IsParent: false }));
    };
    const handleRemove = () => {
        dispatch(SetHierarchy({ Parent_Ticket_Id: null, IsParent: null }));
    }


    const { data: userProfile } = Api.useGetUserProfileQuery();


    return (
        <PanelBar expandMode='single'>
            <PanelBarItem selected={true} expanded={true} title={`${userProfile.Phrases.CallPhrase} hierarchy`} >
                {/* ticket?.Is_Parent:{ticket?.Is_Parent ? 'yes' : 'no'} */}
                <HierarchyForm ticketId={null} isParent={ticket?.Is_Parent} parentCallId={ticket?.Parent_Call_Id} onRemoveHierarchy={handleRemove} onParentChange={handleParentChange} onChildChange={handleChildChange} onTicketSelected={onTicketSelected} />
            </PanelBarItem>
        </PanelBar>
    )
}

type HierarchyProps = {
    onParentChanged?: (e: any) => void;
    onChildChanged?: (e: any) => void;
}

export default TicketHierarchy;
